import { Analytics, WebAnalytics } from '@shared/analytics';

export const withAnalytics = (onError?: (error: unknown) => void) => {
  Analytics.setup(new WebAnalytics({ prefix: 'trweb', onError }));
};
